import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=a1775172&scoped=true&"
import script from "./Verify.vue?vue&type=script&lang=ts&"
export * from "./Verify.vue?vue&type=script&lang=ts&"
import style0 from "./Verify.vue?vue&type=style&index=0&id=a1775172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1775172",
  null
  
)

export default component.exports